// Catatan upload yang belum selesai, supaya upload file besar yang putus di
// tengah jalan ("Failed to fetch", internet mati, tab tertutup) bisa
// DILANJUTKAN - potongan (chunk) yang sudah terkirim ke Discord tidak perlu
// dikirim ulang.
//
// Disimpan di localStorage per akun: { [id]: record }. Satu record berisi
// path tujuan, identitas file (nama, ukuran, tanggal ubah), ukuran potongan
// yang dipakai, dan daftar potongan yang sudah terkirim ({ index: ref }).

const PREFIX = 'disbox_uploads_';

function storageKey(userId) {
    return `${PREFIX}${userId}`;
}

function readAll(userId) {
    try {
        return JSON.parse(localStorage.getItem(storageKey(userId))) || {};
    } catch {
        return {};
    }
}

function writeAll(userId, all) {
    try {
        if (Object.keys(all).length === 0) localStorage.removeItem(storageKey(userId));
        else localStorage.setItem(storageKey(userId), JSON.stringify(all));
    } catch (error) {
        console.warn('[Disbox] Gagal menyimpan catatan upload:', error);
    }
}

export function uploadIdFor(path, file) {
    return `${path}|${file.size}|${file.lastModified || 0}`;
}

export function listPendingUploads(userId) {
    return Object.values(readAll(userId)).sort((a, b) => b.updatedAt - a.updatedAt);
}

export function getPendingUpload(userId, id) {
    return readAll(userId)[id] || null;
}

export function savePendingUpload(userId, record) {
    const all = readAll(userId);
    all[record.id] = { ...record, updatedAt: Date.now() };
    writeAll(userId, all);
}

export function recordUploadedChunk(userId, id, index, ref) {
    const all = readAll(userId);
    const record = all[id];
    if (!record) return;
    record.refs = { ...(record.refs || {}), [index]: ref };
    record.updatedAt = Date.now();
    writeAll(userId, all);
}

export function removePendingUpload(userId, id) {
    const all = readAll(userId);
    delete all[id];
    writeAll(userId, all);
}

export function uploadedBytesOf(record) {
    const count = Object.keys(record.refs || {}).length;
    const lastIndex = record.totalChunks - 1;
    const hasLast = Boolean(record.refs && record.refs[lastIndex]);
    const lastSize = record.size - lastIndex * record.chunkSize;
    return Math.min(record.size, (count - (hasLast ? 1 : 0)) * record.chunkSize + (hasLast ? lastSize : 0));
}
